// frontend/src/pages/Profile/ProfilePage.jsx
import React, { useState } from 'react';
import { useProfile } from '../contexts/ProfileContext';
import ProfileInfo from './ProfileInfo';
import ChangePasswordModal from '../pages/ChangePasswordModal';
import AddressBook from './AddressBook';
import OrderHistory from './OrderHistory';
import ProfileSidebar from './ProfileSidebar';
import LoadingSpinner from '../components/ui/LoadingSpinner';
import AlertMessage from '../components/ui/AlertMessage';
import './profile-page.scss';

const ProfilePage = () => {
    const { profile, loading, error, refreshProfile } = useProfile();
    const [activeTab, setActiveTab] = useState('info');
    const [showPasswordModal, setShowPasswordModal] = useState(false);

    // 👇 AGGIUNGI QUESTO HANDLER
    const handleAvatarUpdate = async (newAvatarUrl) => {
        await refreshProfile(); // Ricarica il profilo per mostrare il nuovo avatar
    };

    if (loading && !profile) {
        return <LoadingSpinner />;
    }

    if (error) {
        return <AlertMessage type="error" message={error} />;
    }

    const tabs = [
        { id: 'info', label: 'Informazioni Personali', icon: '👤' },
        { id: 'addresses', label: 'Indirizzi', icon: '📍' },
        { id: 'orders', label: 'I Miei Ordini', icon: '📦' }
    ];

    return (
        <div className="profile-page">
            <div className="container">
                <div className="profile-header">
                    <h1>Il Mio Profilo</h1>
                    <p>Gestisci i tuoi dati personali, indirizzi e ordini</p>
                </div>

                <div className="profile-content">
                    <ProfileSidebar 
                        profile={profile}
                        activeTab={activeTab}
                        onTabChange={setActiveTab}
                        onChangePassword={() => setShowPasswordModal(true)}
                        onAvatarUpdate={handleAvatarUpdate}
                        tabs={tabs}
                    />

                    <div className="profile-main">
                        {activeTab === 'info' && (
                            <ProfileInfo 
                                profile={profile} 
                                onUpdate={refreshProfile}
                                onChangePassword={() => setShowPasswordModal(true)}
                            />
                        )}
                        
                        {activeTab === 'addresses' && (
                            <AddressBook />
                        )}
                        
                        {activeTab === 'orders' && (
                            <OrderHistory />
                        )}
                    </div>
                </div>

                <ChangePasswordModal 
                    isOpen={showPasswordModal}
                    onClose={() => setShowPasswordModal(false)}
                />
            </div>
        </div>
    );
};

export default ProfilePage;
